import React, { Component } from "react";

class TestimonialItem extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <div className="testimonialitem-title">"{this.props.Desc}"</div>
        <div className="testimonialitem-name">{this.props.name}, 2021</div>
      </div>
    );
  }
}
export default TestimonialItem;
